<template>
  <div>

    <div class="row" >
      <div class="col-sm-6 col-md-4 mb-4" v-for="doc in docs" :key="doc['.key']">
        <div class="c-card card">
          <div class="card-body d-flex flex-column align-items-center text-center">
            <font-awesome-icon class="c-card__icon-file mb-3" :icon="['fal', 'file-pdf']"></font-awesome-icon>
            <h5 class="c-main__title mb-3">{{ doc.name }}</h5>
            <a :href="doc.url" class="btn btn-block btn-warning" target="_blank">View File</a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import { categories } from '../../firebase'

  export default {
    props: [ 'category', 'subcategory' ],
    firestore() {
      return {
        docs: categories.doc(this.category).collection('subcategories').doc(this.subcategory).collection('files')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/Docs.vue